import React, {useEffect, useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {useDeepEffect} from '@nl/ui';
import {getCookie} from '@nl/neu';
import FreeSampleService from '@nl/free-sample';
import useFreeSample from '../../hooks/useFreeSample';
import {setUserFreePreview} from '../../utils/auth';
import FreeSamplePreview from './FreeSamplePreview';
import FreeSampleModal from './FreeSampleModal';
import {event, EVENT_TYPES} from '../../utils/event';

import '../../styles/freesample/freesample.scss';

const ONE_MINUTE = 60;
const FREE_SAMPLE_COOKIE_NAME = 'samplingmodal';

const getCountDownTime = (time) => {
	const mins = parseInt(time / ONE_MINUTE, 10);
	const seconds = parseInt(time % ONE_MINUTE, 10);
	return `${mins} : ${seconds >= 10 ? '' : '0'}${seconds}`;
};

const FreeSampleCountdown = () => {
	const [freeSampleStatus, setFreeSampleStatus] = useState(null);
	const [timeUp, setTimeUp] = useState(false);
	const [leftTime, setLeftTime] = useState(0);
	const [text, setText] = useState(getCountDownTime(0));
	const [showModal, setShowModal] = useState(true);
	const [isDtcLogged, setDtcLogged] = useState(false);
	const freeSampleInitialized = useFreeSample();
	const [enableFreeSample, setFreeSample] = useState(!!getCookie(FREE_SAMPLE_COOKIE_NAME));
	const {user} = useSelector((state) => state.client.data, shallowEqual);

	useDeepEffect(() => {
		if (user && user.dtc && user.dtc.loggedIn) {
			setDtcLogged(true);
		} else {
			setDtcLogged(false);
		}
	}, [user]);

	useEffect(() => {
		if (freeSampleInitialized && enableFreeSample && isDtcLogged) {
			FreeSampleService.checkFreeSample((data) => {
				setFreeSampleStatus(data);
			}, (count) => {
				setLeftTime(count);
				setText(getCountDownTime(count));
			}, (data) => {
				setTimeUp(true);
				setFreeSampleStatus(data);
			}).then();
		}
	}, [freeSampleInitialized, isDtcLogged, enableFreeSample]);

	const duration = freeSampleStatus !== null ? freeSampleStatus.totalTime : 0;
	const isFreeSample = enableFreeSample && isDtcLogged && freeSampleStatus !== null
			&& freeSampleStatus.isEnable && freeSampleStatus.hasStarted && leftTime > 0;
	const isFreeSampleEnd = isDtcLogged && freeSampleStatus !== null
			&& freeSampleStatus.isEnable && timeUp;
	const isUserLoggedOut = !isDtcLogged && freeSampleStatus !== null && freeSampleStatus.isEnable
			&& leftTime > 0;
	const isUserLeave = isDtcLogged && enableFreeSample && freeSampleStatus !== null
			&& !freeSampleStatus.hasStarted;

	useEffect(() => {
		if (!enableFreeSample) {
			setUserFreePreview(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (isFreeSample) {
			setUserFreePreview(true);
			event.trigger(EVENT_TYPES.FREE_SAMPLE_START);
		}
	}, [isFreeSample]);

	useEffect(() => {
		if (isFreeSampleEnd || isUserLoggedOut || isUserLeave) {
			setUserFreePreview(false);
			document.cookie = `${FREE_SAMPLE_COOKIE_NAME}=true;domain=.nba.com;expires=${new Date(0).toUTCString()};path=/`;
			event.trigger(EVENT_TYPES.FREE_SAMPLE_END);
		}
	}, [isFreeSampleEnd, isUserLoggedOut, isUserLeave]);

	const handleModelClose = () => {
		setShowModal(false);
		document.cookie = `${FREE_SAMPLE_COOKIE_NAME}=true;domain=.nba.com;expires=${new Date(0).toUTCString()};path=/`;
		setFreeSample(false);
	};

	return (
			<>
				{isFreeSample && (
						<FreeSamplePreview text={text}
															 value={Math.ceil((leftTime / duration) * 100)}
															 minutes={Math.ceil(duration / ONE_MINUTE)}
						/>
				)}
				{(isFreeSampleEnd || isUserLoggedOut || isUserLeave) && (
						<FreeSampleModal show={showModal}
														 onHide={() => {
															 handleModelClose();
														 }}
														 minutes={Math.ceil(duration / ONE_MINUTE)}
						/>
				)}
			</>
	);
};

export default FreeSampleCountdown;
